import React, { Component } from 'react'

class Screen7A extends Component {

  render() {

    const { entry, addEntry, language, t } = this.props

    return (
      <main>
        <h3>{t(language, 'hateCrimeDetails')}</h3>
        <label>{language === 'hr' ? 'Dodatne napomene' : 'Additional notes'}
          <textarea value={entry.note} onChange={(e) => addEntry('note', null, e)}></textarea>
        </label>
        <p className="hint">{language === 'hr' ? 'ukoliko želite nešto dodati što nije bilo obuhvaćeno upitnikom, ovo je prostor za to.' : 'If you want to add anything that was not covered in the questionnaire, this is the place to do it.'}</p>
      </main>
    );
  }
}

export default Screen7A;
